import axios from 'axios';
import Cookies from 'js-cookie';

const LIFERAY_AUTH_TOKEN = window.Liferay.authToken;
const IS_IMPERSONATING = Boolean(window.Liferay.ThemeDisplay.isImpersonated());
const IMPERSONATE_AS_ID = IS_IMPERSONATING ? window.Liferay.ThemeDisplay.getDoAsUserIdEncoded() : false;

const headers = {
    common: {
        'X-Liferay-Auth-Token': LIFERAY_AUTH_TOKEN,
        'x-csrf-token': LIFERAY_AUTH_TOKEN,
        'XSRF-TOKEN': Cookies.get('XSRF-TOKEN'),
        'merkur_user_session_id': Cookies.get('merkur_user_session_id')
    },
    post: {
        'X-Liferay-Auth-Token': LIFERAY_AUTH_TOKEN,
        'x-csrf-token': LIFERAY_AUTH_TOKEN,
        'XSRF-TOKEN': Cookies.get('XSRF-TOKEN'),
        'merkur_user_session_id': Cookies.get('merkur_user_session_id')
    },
    get: {
        'X-Liferay-Auth-Token': LIFERAY_AUTH_TOKEN,
        'x-csrf-token': LIFERAY_AUTH_TOKEN,
        'XSRF-TOKEN': Cookies.get('XSRF-TOKEN'),
        'merkur_user_session_id': Cookies.get('merkur_user_session_id')
    }
};

if (IS_IMPERSONATING === true) {
    headers.common['X-Liferay-Impersonate-As'] = encodeURIComponent(IMPERSONATE_AS_ID);
}

const instance = axios.create({
    headers,
});

export default instance;
